import $ from 'cash-dom'

$(() => {
  const switchSlide = ($curr, $next) => {
    $curr.toggleClass('opacity-100 opacity-0')
    $next.toggleClass('opacity-100 opacity-0')
    setTimeout(() => {
      $curr.toggleClass('relative z-2 absolute z-1')
      $next.toggleClass('absolute z-1 relative z-2')
    }, 500)
  }

  $('.spotlight-next').on('click', () => {
    const $curr = $('.spotlight-item.relative')
    const $first = $('.spotlight-item:first-child')
    const $next = $curr.next().length > 0 ? $curr.next() : $first
    switchSlide($curr, $next)
  })
  $('.spotlight-prev').on('click', () => {
    const $curr = $('.spotlight-item.relative')
    const $last = $('.spotlight-item:last-child')
    const $prev = $curr.prev().length > 0 ? $curr.prev() : $last
    switchSlide($curr, $prev)
  })
})
